import { el } from "./dom";
import { t } from "../i18n";
import { settings } from "../store/settings";
import { progress } from "../store/progress";
import { tier, MAX_TIER } from "../game/tiers";
import { tierSwatch } from "../render/renderer";

/** Tier level currently used as the profile avatar (defaults to particle/tier 1). */
export function profileLevel(): number {
  const pt = settings.snapshot.profileTier;
  return pt >= 1 ? pt : 1;
}

/**
 * Modal to pick a profile avatar. Only discovered tiers (1..maxTierReached)
 * are selectable; undiscovered tiers show as locked.
 */
export function openProfilePicker(host: HTMLElement, onDone: () => void): void {
  const backdrop = el("div", "modal-backdrop");
  const modal = el("div", "panel modal profile-modal");
  backdrop.appendChild(modal);
  host.appendChild(backdrop);

  const maxReached = Math.max(1, progress.snapshot.maxTierReached);
  const current = profileLevel();

  modal.appendChild(el("h2", "", t("profile.pick")));

  const grid = el("div", "profile-grid");
  for (let lv = 1; lv <= MAX_TIER; lv++) {
    const discovered = lv <= maxReached;
    const cell = el(
      "button",
      `profile-cell ${lv === current ? "selected" : ""} ${discovered ? "" : "locked"}`,
    );
    cell.innerHTML = `
      <span class="pc-art">${discovered ? tierSwatch(lv, 46) : "🔒"}</span>
      <span class="pc-name">${discovered ? t(`tier.${tier(lv).key}`) : "???"}</span>`;
    if (discovered) {
      cell.onclick = () => {
        settings.set("profileTier", lv);
        backdrop.remove();
        onDone();
      };
    } else {
      cell.disabled = true;
    }
    grid.appendChild(cell);
  }
  modal.appendChild(grid);

  // ---- Title picker (idea #12): equip an unlocked achievement as a title
  // shown next to the name on the leaderboard. ----
  const owned = progress.snapshot.achievements;
  if (owned.length > 0) {
    modal.appendChild(el("h2", "", t("title.pick")));
    const titleRow = el("div", "title-list");
    const mkTitle = (id: string, label: string, active: boolean): HTMLElement => {
      const b = el("button", `title-chip ${active ? "selected" : ""}`, label);
      b.onclick = () => {
        settings.set("activeTitle", id);
        backdrop.remove();
        onDone();
      };
      return b;
    };
    const activeTitle = settings.snapshot.activeTitle;
    titleRow.appendChild(mkTitle("", t("title.none"), activeTitle === ""));
    for (const id of owned) {
      titleRow.appendChild(mkTitle(id, t(`ach.${id}`), activeTitle === id));
    }
    modal.appendChild(titleRow);
  }

  const close = el("button", "btn-primary", t("common.close"));
  close.onclick = () => backdrop.remove();
  modal.appendChild(close);

  backdrop.onclick = (e) => {
    if (e.target === backdrop) backdrop.remove();
  };
}
